module.exports = __webpack_public_path__ + "static/media/pic6.37592e60.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/photography/pic6.png
// module id = 317
// module chunks = 0